import { RegistrationTransportOption } from '../registration-transport-option';

export class TransportRouteSelection {
    vehicleId: number;
    transportOptions: Array<RegistrationTransportOption>;
}
